import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      opacity: ".5",
      cx: "12",
      cy: "9",
      r: "3",
      stroke: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      opacity: ".5",
      d: "M17.97 20c-.16-2.892-1.045-5-5.97-5s-5.81 2.108-5.97 5",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render };